import React, { useEffect, useState } from 'react';
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import {
  Grid,
  InputLabel,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  useMediaQuery,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import TitleBar from '../TitleBar';
import { Items } from '../TitleList';
import { useDispatch, useSelector } from 'react-redux';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import { fetchItemData, insertItemMaterial } from '../../Store/PHPSlice/Item';
import { fetchBrandData } from '../../Store/PHPSlice/Rack';
import { fetchMaterialData } from '../../Store/PHPSlice/Material';
import { fetchDepartmentData } from '../../Store/PHPSlice/Department';
import { insertItemPriceList } from '../../Store/PHPSlice/ItemPriceList';


import { selectItems } from '../Selectors/Master/ItemSelectors';
import { selectMaterials } from '../Selectors/Master/OutwardSelectors';
import { selectDaparement } from '../Selectors/Master/MasterSelectors';
import axios from 'axios';

const ItemPriceList = () => {
  const userdata = JSON.parse(localStorage.getItem('user'));
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [formData, setFormData] = useState({
    item: '',
    clothName: '',
    userId: userdata?.ID
  });

  const [addedRows, setAddedRows] = useState([]);
  const [sizeWise, setSizeWise] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [viewData, setViewData] = useState({});

  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const isDesktop = useMediaQuery('(min-width:768px)');

  const itemlist = useSelector(selectItems);
  const materiallist = useSelector(selectMaterials);
  const departlist = useSelector(selectDaparement);

  /* -------------------- LOAD MASTER DATA -------------------- */
  useEffect(() => {
    dispatch(fetchItemData());
    dispatch(fetchBrandData());
    dispatch(fetchMaterialData());
    dispatch(fetchDepartmentData());
  }, [dispatch]);

  const fetchExistedItemClothAPI = async (id, clothNm) => {
    try {
      const res = await axios.get(`${baseUrl}?apicall=getItemPriceListValidationExistedAPI&itemId=${id}&clothNm=${clothNm}`);

      return res.data;
    } catch (error) {
      console.error('error', error);
    }
  };

  /* -------------------- PREPARE SIZE DATA ON ITEM CLICK -------------------- */
  const prepareSizeWiseData = (itemId) => {
    if (!itemId || !itemlist?.data) {
      setSizeWise([]);
      return;
    }

    const selectedItem = itemlist.data.find(i => i.ID === itemId);
    if (!selectedItem?.size) {
      setSizeWise([]);
      return;
    }

    const sizes = selectedItem.size.split(',');

    setSizeWise(
      sizes.map(s => ({
        size: s.trim(),
        muRate: '',
        sRate: '',
        nRate: ''
      }))
    );
  };

  /* -------------------- ITEM DROPDOWN CHANGE -------------------- */
  const handleItemChange = (newValue) => {
    const itemId = newValue ? newValue.ID : '';
    setFormData(prev => ({ ...prev, item: itemId }));
    prepareSizeWiseData(itemId);
  };
  const handleCheckboxChange = (index) => {
    setSelectedRows(prev =>
      prev.includes(index)
        ? prev.filter(i => i !== index)
        : [...prev, index]
    );
  };
  const handleDeleteSelected = () => {
    setAddedRows(prev =>
      prev.filter((_, index) => !selectedRows.includes(index))
    );
    setSelectedRows([]);
    setOpenIndex(null);
  };


  /* -------------------- INPUT CHANGE -------------------- */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: name === 'clothName' ? value.toUpperCase() : value
    }));
  };

  /* -------------------- SIZE INPUT CHANGE -------------------- */
  const handleSizeChange = (index, field, value) => {
    setSizeWise(prev =>
      prev.map((row, i) =>
        i === index ? { ...row, [field]: value } : row
      )
    );
  };
  const handleView = (index) => {
    const selected = addedRows[index];
    if (!selected) return;

    // setFormData(prev => ({
    //   ...prev,
    //   item: selected.itemId,
    //   clothName: selected.clothName
    // }));

    // // Clone rows to avoid reference mutation
    // setSizeWise(
    //   selected.rows.map(r => ({
    //     size: r.size,
    //     muRate: r.muRate,
    //     sRate: r.sRate,
    //     nRate: r.nRate
    //   }))
    // );
    // console.log(selected);
    setViewData(selected);
    // optional: close expanded row
    setOpenIndex(null);
  };
  const isAddDisabled = () => {
    if (!formData.clothName.trim()) return true;
    if (sizeWise.length === 0) return true;

    // Enable if at least one size has any rate filled
    const hasAnyRate = sizeWise.some(
      row =>
        row.muRate !== '' ||
        row.sRate !== '' ||
        row.nRate !== ''
    );

    return !hasAnyRate;
  };

  const handleAddTableData = async () => {
    if (!formData.clothName.trim()) {
      alert('Please Enter Cloth Name');
      return;
    }

    if (sizeWise.length === 0) return;

    const response = await fetchExistedItemClothAPI(formData.item, formData.clothName);
    // console.log(response);
    if (response.status === "success") {
      alert(response.msg);
    } else {
      const selectedItem = itemlist?.data?.find(
        i => i.ID === formData.item
      );

      setAddedRows(prev => [
        ...prev,
        {
          itemId: formData.item,
          itemName: selectedItem?.itemNm || '',
          clothName: formData.clothName,
          rows: sizeWise
        }
      ]);

      // ✅ RESET FORM
      setFormData(prev => ({
        ...prev,
        item: '',
        clothName: ''
      }));

      // ✅ CLEAR SIZE TABLE
      setSizeWise([]);
    }

  };
  const handleDelete = (index) => {
    setAddedRows(prev => prev.filter((_, i) => i !== index));
    if (openIndex === index) setOpenIndex(null);
  };



  /* -------------------- SUBMIT -------------------- */
  const handleSubmit = async () => {
    if (addedRows.length === 0) {
      alert('Please add at least one price list');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        priceLists: addedRows.map(entry => ({
          itemId: entry.itemId,
          clothName: entry.clothName,
          sizeData: entry.rows
        })),
        userId: formData.userId
      };

      await dispatch(insertItemPriceList(payload)).unwrap();

      alert('All price lists saved successfully');
      window.location.reload();
    } catch (err) {
      console.error(err);
      alert('Something went wrong');
    } finally {
      setLoading(false);
    }
  };


  /* -------------------- DROPDOWN CONFIG -------------------- */
  const dropdownlistfirst = [
    {
      label: 'Item',
      id: 'item',
      options: itemlist?.data || [],
      value: formData.item,
      onChange: handleItemChange,
      getOptionLabel: option => option.itemNm || '',
      isOptionEqualToValue: (o, v) => o.ID === v.ID,
      valueFinder: (options, value) =>
        options.find(i => i.ID === value) || null
    }
  ];

  /* ==================== JSX ==================== */
  return (
    <>
      <TitleBar data={Items} />

      <div style={{ margin: '1%' }}>
        <h2>Item - Price List Entry</h2>

        <Paper style={{ padding: '2vh' }}>
          <Grid container spacing={2}>

            {/* ITEM DROPDOWN */}
            {dropdownlistfirst.map(drop => (
              <DropdownWithBtn key={drop.id} {...drop} isDesktop={isDesktop} />
            ))}

            {/* CLOTH NAME */}
            <Grid item xs={12} md={6}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item xs={3}>
                  <InputLabel>Cloth Name :</InputLabel>
                </Grid>
                <Grid item xs={9}>
                  <TextField
                    fullWidth
                    size="small"
                    name="clothName"
                    value={formData.clothName}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* TABLE — SHOW ONLY WHEN ITEM IS SELECTED */}
            {formData.item && sizeWise.length > 0 && (
              <Grid item xs={12}>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row' l>Size</TableCell>
                        {sizeWise.map((row, i) => (
                          <TableCell key={i} sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>{row.size}</TableCell>
                        ))}
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>MU</TableCell>
                        {sizeWise.map((row, i) => (
                          <TableCell key={i} sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' >
                            <input
                              value={row.muRate}
                              onChange={e =>
                                handleSizeChange(i, 'muRate', e.target.value)
                              }
                              style={{ width: '60px', height: '30px', textAlign: 'center' }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>S</TableCell>
                        {sizeWise.map((row, i) => (
                          <TableCell key={i} sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                            <input
                              value={row.sRate}
                              onChange={e =>
                                handleSizeChange(i, 'sRate', e.target.value)
                              }
                              style={{ width: '60px', height: '30px', textAlign: 'center' }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>N</TableCell>
                        {sizeWise.map((row, i) => (
                          <TableCell key={i} sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                            <input
                              value={row.nRate}
                              onChange={e =>
                                handleSizeChange(i, 'nRate', e.target.value)
                              }
                              style={{ width: '60px', height: '30px', textAlign: 'center' }}
                            />
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                {formData.item && sizeWise.length > 0 && (
                  <Grid item xs={12} textAlign="left" mt={2}>
                    <Button variant="contained" onClick={handleAddTableData} disabled={isAddDisabled()}>
                      Add
                    </Button>

                  </Grid>
                )}

              </Grid>
            )}

            {viewData && Object.keys(viewData || {}).length > 0 &&
              <div style={{ margin: '10px' }}>

                <h4> Item : {viewData.itemName}</h4>
                <h4> Cloth Name : {viewData.clothName}</h4>
                <button style={{ background: 'orange' }}>
                  <CloseIcon onClick={() => setViewData({})} />
                </button>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row' l>Size</TableCell>
                        {viewData?.rows?.map((row, i) => (
                          <TableCell key={i} sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>{row.size}</TableCell>
                        ))}
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>MU</TableCell>
                        {viewData?.rows?.map((row, i) => (
                          <TableCell key={i} sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' >
                            {/* <input
                              value={row.muRate}
                              onChange={e =>
                                handleSizeChange(i, 'muRate', e.target.value)
                              }
                              style={{ width: '60px', height: '30px', textAlign: 'center' }}
                            /> */}
                            {row.muRate}
                          </TableCell>
                        ))}
                      </TableRow>

                      <TableRow>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>S</TableCell>
                        {viewData?.rows?.map((row, i) => (
                          <TableCell key={i} sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                            {/* <input
                              value={row.sRate}
                              onChange={e =>
                                handleSizeChange(i, 'sRate', e.target.value)
                              }
                              style={{ width: '60px', height: '30px', textAlign: 'center' }}
                            /> */}
                            {row.sRate}
                          </TableCell>
                        ))}
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>N</TableCell>
                        {viewData?.rows?.map((row, i) => (
                          <TableCell key={i} sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center'>
                            {/* <input
                              value={row.nRate}
                              onChange={e =>
                                handleSizeChange(i, 'nRate', e.target.value)
                              }
                              style={{ width: '60px', height: '30px', textAlign: 'center' }}
                            /> */}

                            {row.nRate}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>}

            {addedRows.length > 0 && (
              <div>
                <h3>Added Price List</h3>

                <TableContainer>

                  <Grid item xs={12} mt={2} textAlign="right">

                  </Grid>

                  <Table>
                    <TableBody>

                      {/* HEADER */}
                      <TableRow>
                        <TableCell colSpan={5} sx={{ p: 1, borderBottom: '1px solid #000', borderRight: '1px solid #fff', borderTop: '1px solid #fff', borderLeft: '1px solid #fff', width: '150px' }}>
                          <Button
                            size="small"
                            variant="contained"
                            color="error"
                            onClick={handleDeleteSelected}
                            disabled={selectedRows.length === 0}
                          >
                            Delete
                          </Button>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                          Sr No
                        </TableCell>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                          Item Name
                        </TableCell>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                          Cloth Name
                        </TableCell>
                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>
                          View
                        </TableCell>

                      </TableRow>

                      {/* ROWS */}
                      {addedRows.map((entry, idx) => (
                        <React.Fragment key={idx}>
                          <TableRow>
                            <TableCell sx={{ border: '1px solid #000' }} align="center">
                              <input
                                type="checkbox"
                                checked={selectedRows.includes(idx)}
                                onChange={() => handleCheckboxChange(idx)}
                              />
                              {idx + 1}

                            </TableCell>
                            <TableCell sx={{ border: '1px solid #000' }} align="center">
                              {entry.itemName}
                            </TableCell>

                            <TableCell sx={{ border: '1px solid #000' }} align="center">
                              {entry.clothName}
                            </TableCell>
                            <TableCell sx={{ border: '1px solid #000' }} align="center">
                              <IconButton
                                size="small"
                                onClick={() => handleView(idx)}
                              >
                                <VisibilityIcon />
                              </IconButton>

                            </TableCell>

                          </TableRow>

                          {/* EXPANDED PRICE LIST */}
                          {openIndex === idx && (
                            <TableRow>
                              <TableCell
                                colSpan={4}
                                sx={{ border: '1px solid #000', p: 1 }}
                              >
                                <Table>
                                  <TableBody>

                                    <TableRow>
                                      <TableCell align="center">Size</TableCell>
                                      {entry.rows.map((r, i) => (
                                        <TableCell key={i} align="center">{r.size}</TableCell>
                                      ))}
                                    </TableRow>

                                    <TableRow>
                                      <TableCell align="center">MU</TableCell>
                                      {entry.rows.map((r, i) => (
                                        <TableCell key={i} align="center">{r.muRate}</TableCell>
                                      ))}
                                    </TableRow>

                                    <TableRow>
                                      <TableCell align="center">S</TableCell>
                                      {entry.rows.map((r, i) => (
                                        <TableCell key={i} align="center">{r.sRate}</TableCell>
                                      ))}
                                    </TableRow>

                                    <TableRow>
                                      <TableCell align="center">N</TableCell>
                                      {entry.rows.map((r, i) => (
                                        <TableCell key={i} align="center">{r.nRate}</TableCell>
                                      ))}
                                    </TableRow>

                                  </TableBody>
                                </Table>
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      ))}

                    </TableBody>
                  </Table>
                </TableContainer>


                {/* SUBMIT */}
                <Grid item xs={12} textAlign="center">
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                </Grid>
              </div>

            )}



          </Grid>
        </Paper>
      </div>
    </>
  );
};

export default ItemPriceList;
